import React, { Component } from "react";
import { Link } from "react-router";

class NavBar extends Component {
  render() {
    return (
      <ul className="account-settings">
        <li>
          <Link to={`/account/basic`} activeClassName="active-tab">
            <span>Basic</span>
          </Link>
        </li>
        <li>
          <Link to={`/account/preferences`} activeClassName="active-tab">
            <span>Contact preferences</span>
          </Link>
        </li>
        <li>
          <Link
            to={`/account/jobs-and-member-preferences`}
            activeClassName="active-tab"
          >
            <span>Job and member preferences</span>
          </Link>
        </li>
        <li>
          <Link
              to={`/account/location-preferences`}
              activeClassName="active-tab"
          >
              <span>Location Preferences</span>
          </Link>
        </li>
      </ul>
    );
  }
}


export default NavBar;



// WEBPACK FOOTER //
// src/client/components/site/features/account/common/NavBar.js